/**
 * Componente TenantGuard
 * Valida se o subdomínio/tenant é válido antes de renderizar o conteúdo
 */

import React from "react";
import { useTenant } from "../../hooks/useTenant";
import InvalidSubdomain from "../../pages/InvalidSubdomain";

const TenantGuard = ({ children }) => {
  const { isValid } = useTenant();

  // Se o tenant não for válido, mostra página de erro
  if (!isValid) {
    return <InvalidSubdomain />;
  }

  // Se válido, renderiza o conteúdo normalmente
  return <>{children}</>;
};

export default TenantGuard;
